/**
 * Created by Jason on 2017-5-12.
 */
import util from '../../js/util';
import download from '../../js/download';

//获取文件修改时间
function getTime (file) {
    return file.lastModified || file.lastModifiedDate.getTime()
}
module.exports = class {
    /**
     *
     * @param fields 文件列表中name和size字段对应
     * @param confirm 确定按钮时回掉
     * @param maxAllSize 最大文件大小
     * @param maxAllNumber 文件个数
     * @param el 点击的标签
     * @param downloadProp 下载属性回掉
     * @param cancel
     * @param zIndex
     */
    constructor({fields = {}, downloadProp = null, cancel = null,
             confirm = null, maxAllSize = 0, maxAllNumber = 0, el = null, zIndex = 2000}) {
        let ts = this
        ts.filesCache = {}
        ts.uploadFiles = []
        ts._render();
        ts._bindEvent();
        ts.cancel(true);

        ts.downloadProp = downloadProp;
        ts.nameField = fields.name || 'name'
        ts.sizeField = fields.size || 'size'
        
        //其他属性
        ts.confirm = confirm;
        ts.maxAllSize = maxAllSize;
        ts.cancelCb = cancel;
        //提示文件
        let m = maxAllSize / 1000000;
        if (m > 1) {
            ts.maxSizeStr = Math.ceil(m) + 'MB';
        } else {
            m = maxAllSize / 1000;
            if (m > 1) {
                ts.maxSizeStr = Math.ceil(m) + 'KB';
            } else {
                ts.maxSizeStr = maxAllSize + 'B';
            }
        }
        ts.maxAllNumber = maxAllNumber;
        ts.el = $(el)[0];
        ts.$box.css('z-index', zIndex);
    }
    /**
     * 渲染dom
     */
    _render() {
        let ts = this
        let $body = $(document.body)
        $body.append(`<div class="panel panel-default upload-box">
            <h4 class="panel-heading">上传附件(限制10个附件，100MB。)</h4>
            <div class="panel-body">
                <div class="file-empty">没有附件</div>
                <ul class="server-list attachment-list"></ul>
                <ul class="upload-list attachment-list"></ul>
            </div>
            <div class="panel-footer">
                <button class="btn btn-default btn-xs select-file" type="button">选择附件</button>
                <input type="file" class="upload-box-file" multiple="multiple">
                <button class="btn btn-danger btn-xs cancel-file" type="button">放弃修改</button>
                <button class="btn btn-success btn-xs confirm-file" type="button">确定</button>
                <span class="tips"></span>
            </div>
        </div>`);
        let $box = ts.$box = $body.find('.upload-box').last()
        ts.$tips = $box.find('.tips').eq(0)
        ts.$selcet = $box.find('.select-file').eq(0);
        ts.$confirm = $box.find('.confirm-file').eq(0);
        ts.$file = $box.find('.upload-box-file').eq(0);
        ts.$list = $box.find('.panel-body').eq(0);
        ts.$serverList = $box.find('.server-list').eq(0);
        ts.$uploadList = $box.find('.upload-list').eq(0);
        ts.$empty = $box.find('.file-empty').eq(0);
        ts.$cancel = $box.find('.cancel-file').eq(0);
    }
    /**
     * 清空
     * @private
     */
    cancel(isIn = false) {
        let ts = this
        ts.uploadFiles = [];
        ts.filesCache = {}
        ts.$box.removeAttr('style');
        ts.isHide = true;
        if (!isIn) {
            ts.cancelCb();
        }
    }
    /**
     * 绑定事件
     */
    _bindEvent() {
        let ts = this
        let $file = ts.$file
        //选择文件
        ts.$selcet.on('click', () => {
            $file.trigger('click')
        });
        //文件选择后事件
        $file.on('change', () => {
            let $files = $file.prop('files')
            let len = $files.length;
            if (!len) {
                return
            }
            let html = '';
            for (let i = 0; i < len; i++) {
                let item = $files[i];
                let key = item.name + '/' + item.size + '/' + getTime(item);
                //需要过滤同样的文件
                if (ts.filesCache[key]) {
                    util.error('忽略附件', '过滤了相同的附件：' + item.name + '。');
                    continue
                }
                //查看个数限制
                if (ts.number + 1 > ts.maxAllNumber) {
                    util.error('忽略附件', '最多只能上传' + ts.maxAllNumber + '个附件。');
                    break;
                }
                //查看大小限制
                if (ts.size + item.size > ts.maxAllSize) {
                    util.error('忽略附件', '一共只能上传' + ts.maxSizeStr + '的附件。');
                    break;
                }
                //累加html
                html += ts._appendFile(item, key);
            }
            ts.$uploadList.append(html);
            ts._changeHandler();
            $file.val('');
        })
        //下载监听
        download.addListener(ts.$serverList);
        //删除监听
        ts.$serverList.add(ts.$uploadList).on('click', (e) => {
            let $t = $(e.target);
            if ($t.data('active') === 'remove') {
                switch ($t.data('type')) {
                    case 'server':
                        remove($t, ts.remoteFiles)
                        break;
                    case 'upload':
                        let item = remove($t, ts.uploadFiles)
                        ts.filesCache[item.name + '/' + item.size + '/' + getTime(item)] = false;
                        break;
                } 
            }
        })
        /**
         * 删除
         * @param $t
         * @param arr
         */
        function remove ($t, arr) {
            let $parent = $t.parent();
            let index = $parent.index()
            $parent.remove();
            ts.size -= $t.data('size');
            ts.number--;
            let item = arr[index];
            arr.splice(index, 1);
            ts._changeHandler();
            return item;
        }
        //确定监听
        ts.$confirm.on('click', () => {
            ts.confirm(ts.remoteFiles, ts.uploadFiles);
            ts.cancel(true);
        });
        //位置监听
        $(window).on('resize', () => {
            ts._boxPosition();
        });
        //取消
        ts.$cancel.on('click', () => {
            ts.cancel(true);
        });
        
    }
    /**
     * 追加本地文件
     * @param file
     * @param key
     * @private
     */
    _appendFile(file, key) {
        let ts = this;
        let size = file.size;
        let name = file.name;
        //个数和大小累加
        ts.number ++;
        ts.size += size;
        //缓存文件名字大小和修改日期
        key = key || (name + '/' + size + '/' + getTime(file));
        ts.filesCache[key] = true;
        //累加数据
        ts.uploadFiles.push(file);
        //累加html
        return `<li><span class="new"></span><a title="${name}" href="javascript:;">
                ${util.getFileIcon(null, name)} ${name}</a><span class="fa fa-remove attachment-remove" data-type="upload" 
                data-active="remove" title="删除" data-key="${key}" data-size="${size}"></span></li>`;
    }
    
    /**
     * 插入文件
     * @private
     */
    _changeHandler() {
        let ts = this;
        if (!ts.remoteFiles.length && !ts.uploadFiles.length) {
            ts.$empty.show();
        } else {
            ts.$empty.hide();
        }
        ts._boxPosition();
    }

    /**
     显示上传
     * @param remoteFiles 文件列表
     * @param uploadFiles 已选的本地上传文件列表
     */
    show({remoteFiles = [], uploadFiles = []}) {
        let ts = this
        ts.size = 0;
        ts.number = 0;
        let list = ''
        //远程文件渲染
        let remoteFilesCache = [];
        remoteFiles.forEach((file) => {
            ts.number++
            ts.size += (file[ts.sizeField] - 0);
            let name = file[ts.nameField];
            list += `<li><a href="javascript:;" ${ts.downloadProp ? ts.downloadProp(file) : ''} title="下载：${name}">
                ${util.getFileIcon(null, name)} ${name}</a><span class="fa fa-remove attachment-remove" data-type="server" 
                data-active="remove" title="删除" data-size="${file[ts.sizeField]}"></span></li>`;
            remoteFilesCache.push(file);
        });
        ts.$serverList.html(list);
        ts.remoteFiles = remoteFilesCache;
        //已选文件渲染
        list = '';
        let uploadFilesCache = [];
        uploadFiles.forEach((file)=> {
            list += ts._appendFile(file);
            uploadFilesCache.push(file);
        });
        ts.$uploadList.html(list);
        ts.uploadFiles = uploadFilesCache;
        
        ts.isHide = false;
        ts._changeHandler();
    }
    /**
     * 显示位置
     * @private
     */
    _boxPosition() {
        let ts = this;
        if (ts.isHide) {
            return;
        }
        let offset = ts.el.getBoundingClientRect();
        ts.$box.css({
            'top': offset.top - ts.$box.outerHeight(),
            'left': offset.left
        });
    }
}



// WEBPACK FOOTER //
// ./src/assets/lib/upload-box/index.js